import { useState } from "react";
import { Step } from "./Step";
import WelcomeModal from "./WelcomeModal";

const Welcome = ({ closeModal }: { closeModal: () => void }) => {
  const [step, setStep] = useState<number>(0);

  return (
    <WelcomeModal isOpen={true}>
      <Step step={step} setStep={setStep} closeOnboarding={closeModal} />
    </WelcomeModal>
  );
};

export default Welcome;
